import { useState, useEffect } from 'react'
import { consumirApi } from '../../../utils/consumoApi'
import { useNavigate } from 'react-router-dom'
import { agregarDatosEmpresaUsuario } from '../../../utils/empresaUsuario'
import { format } from 'date-fns';
import { useLocation } from "react-router-dom";
import ErrorAlert from '../../../components/common/ErrorAlert'
import Button from '../../../components/common/Button'
import Modal from '../../../components/modals/Modal'
import DesplegableDinamico from '../../../components/modals/DesplegableDinamico'
import Form from '../../../components/forms/Form'
import Input from '../../../components/common/Input'
import Notification from '../../../components/common/Notification'
import Spinner from '../../../components/common/Spinner'
import Paquete from './Paquete';
import Plazo from './Plazo';
import ProgramaArquitectonico from './ProgramaArquitectonico';
import useCargaInicial from './hooks/useCargaInicial';
import useClientes from './hooks/useClientes';
import useUbicaciones from './hooks/useUbicaciones';

const Cotizaciones = () => {
  const navigate = useNavigate()
  const routeLocation = useLocation();

  const { tiposProyectoDatos, espaciosDatos, plazoElaboracionDatos, idFormaPago, formaPago, setIdFormaPago, manejadorFormaPago } = useCargaInicial();
  // clientes
  const {
    clientes,
    busquedaCliente,
    clientesSeleccionados,
    setClientesSeleccionados,
    mostrarModalSeleccionarCliente,
    seleccionarCliente,
    manejarBusquedaCliente,
    manejarSeleccionCliente,
    limpiarCamposClientes,
    eliminarClienteSeleccionado,
  } = useClientes();
  // ubicaciones 
  const { ubicaciones, busquedaUbicacion, ubicacionGeneral, idUbicacion, costoUbicacion, mostrarModalSeleccionarUbicacion, setIdUbicacion, setUbicacionGeneral, seleccionarUbicacion, setCostoUbicacion, manejarBusquedaUbicacion, manejarSeleccionUbicacion, limpiarCamposUbicaciones } = useUbicaciones();

  // tipo de proyecto 
  const [id, setId] = useState(routeLocation.state?.id || null);
  const [cargando, setCargando] = useState(true); // Indicador de carga
  const [idTipoProyecto, setIdTipoProyecto] = useState("");
  const [cuotas, setCuotas] = useState([]);

  //proyecto
  const [nombreProyecto, setNombreProyecto] = useState("");

  const [ubicacionEspecifica, setUbicacionEspecifica] = useState("");
  //proyecto-detalle
  const [areaTerreno, setAreaTerreno] = useState("");
  const [areaIntervenir, setAreaIntervenir] = useState("");
  const [numeroPisos, setNumeroPisos] = useState("");
  const [azotea, setAzotea] = useState("");

  //cotizacion
  const [fechaCotizacion, setFechaCotizacion] = useState();
  //niveles
  const [niveles, setNiveles] = useState(0);
  const [nivelesAgregados, setNivelesAgregados] = useState([]);
  //paquetes
  const [paquetesDatos, setPaquetesDatos] = useState([])
  const [idPaquete, setIdPaquete] = useState("");
  // Estado para manejar los paquetes agregados
  const [paquetesAgregados, setPaquetesAgregados] = useState([]);

  //plazo de elaboracion
  const [idPlazo, setIdPlazo] = useState("");
  // const [idFormaPago, setIdFormaPago] = useState("");
  const [plazosAgregados, setPlazosAgregados] = useState([]);
  const [dias, setDias] = useState({});


  //// notificaciones y cargas 
  const [error, setError] = useState("")
  const [errorPaquetes, setErrorPaquetes] = useState("")
  const [errorPlazos, setErrorPlazos] = useState("")
  const [errorGeneral, setErrorGeneral] = useState("")
  const [notificacion, setNotificacion] = useState({ estado: false, tipo: "", mensaje: "" })
  const [isSubmitting, setIsSubmitting] = useState(false);
  const idEmpresa = JSON.parse(localStorage.getItem('empresa'))


  useEffect(() => {
    const fetchCotizacion = async () => {
      if (!id) return;

      try {
        const respuesta = await consumirApi('GET', `cotizacion/editar/${id}`);
        if (respuesta.data) {
          let cotizacion = respuesta.data.cotizaciones[0];
          let proyecto = respuesta.data.proyecto;
          setFechaCotizacion(cotizacion.fecha_cotizacion);
          setIdTipoProyecto(proyecto.tipo_proyecto.id);
          obtenerPaquetes(proyecto.tipo_proyecto.id)
          setClientesSeleccionados(proyecto.clientes)
          setNombreProyecto(proyecto.nombre);
          setIdUbicacion(proyecto.ubicacion_maestro.id)
          setCostoUbicacion(proyecto.ubicacion_maestro.costo_viatico)
          setUbicacionGeneral(proyecto.ubicacion_maestro.ciudad)
          setUbicacionEspecifica(proyecto.ubicacion);
          setAreaTerreno(proyecto.proyecto_detalle.area_terreno);
          setNumeroPisos(proyecto.proyecto_detalle.numero_pisos);
          setAreaIntervenir(proyecto.proyecto_detalle.area_intervenir);
          setIdFormaPago(cotizacion.forma_pago)
          setAzotea(proyecto.proyecto_detalle.azotea ? 1 : 0);
          setNiveles(proyecto.proyecto_detalle.niveles)
          setNivelesAgregados(proyecto.programa_arquitectonico)
          setPaquetesAgregados(cotizacion.cotizacionDetalle)

          const cuotasAgrupadas = {};

          cotizacion.cotizacionDetalle.forEach(({ cuotas }) => {
            cuotas.forEach(({ numero_cuota, monto, paquete_id }) => {
              if (!cuotasAgrupadas[paquete_id]) {
                cuotasAgrupadas[paquete_id] = [];
              }

              // Buscar si la cuota ya existe en la lista del paquete
              const cuotaExistente = cuotasAgrupadas[paquete_id].find(c => c.numero_cuota === numero_cuota);

              if (cuotaExistente) {
                cuotaExistente.monto = (parseFloat(cuotaExistente.monto) + parseFloat(monto)).toFixed(2);
              } else {
                cuotasAgrupadas[paquete_id].push({
                  numero_cuota,
                  monto,
                  paquete_id
                });
              }
            });
          });

          setCuotas(cuotasAgrupadas)

          setPlazosAgregados(cotizacion.plazos)
          const resultado = cotizacion.plazos.reduce((acumulador, tramite) => {
            tramite.plazos_detalle.forEach((detalle) => {
              acumulador[detalle.id] = detalle.dias;
            });
            return acumulador;
          }, {});
          setDias(resultado)
          setCargando(false);
        }
      } catch (error) {
        console.error("Error al obtener la cotización:", error);
      }
    };

    fetchCotizacion();
  }, [id]);



  // Manejador para el cambio de tipo de proyecto
  const manejadorTipoProyecto = async (idTipoProyecto) => {
    // Verifica si el idTipoProyecto no está vacío
    if (!idTipoProyecto == '') {
      setIdTipoProyecto(idTipoProyecto);
      obtenerPaquetes(idTipoProyecto);
      // Resetea los paquetes agregados y las cuotas
      setPaquetesAgregados([]);
      setCuotas([]);
    }
  }

  // Función para obtener los paquetes según el tipo de proyecto seleccionado
  const obtenerPaquetes = async (idTipoProyecto) => {
    const respuesta = await consumirApi('GET', `maestros/paquete/tipo-proyecto/${idTipoProyecto}/${idEmpresa}`);
    setPaquetesDatos(respuesta.data);
  }

  // Función para agregar un paquete al listado de paquetes agregados
  const agregarPaquete = (e, costoUbicacion) => {
    e.preventDefault();
    setErrorPaquetes("");
    // Verifica si se ha seleccionado un paquete
    if (idPaquete) {
      const paqueteSeleccionado = paquetesDatos.find((paquete) => paquete.id == idPaquete);

      if (paqueteSeleccionado) {
        // Verifica si el paquete ya ha sido agregado
        const paqueteExiste = paquetesAgregados.some((paquete) => paquete.id === paqueteSeleccionado.id);
        if (!paqueteExiste) {
          // Calcula el monto total de cada acción dentro del paquete
          const accionesConMonto = paqueteSeleccionado.secciones.map((seccion) => {
            const accionesConMontoCalculado = seccion.acciones.map((accion) => {
              const costoBase = parseFloat(accion.costo_base) || 0;  // Costo base de la acción
              const costoUbi = parseFloat(costoUbicacion) || 0;  // Costo por ubicación
              const metraje = parseFloat(areaTerreno) || 0;  // Metraje
              let montoTotal = costoBase;

              // Si la acción está sujeta a metraje, se ajusta el costo
              if (accion.sujeto_metraje) {
                montoTotal *= metraje;
              }

              // Si la acción está sujeta a ubicación, se ajusta el costo
              if (accion.sujeto_ubicacion) {
                montoTotal += costoUbi;
              }
              return { ...accion, montoTotal };
            });

            return { ...seccion, acciones: accionesConMontoCalculado };
          });

          // Agrega el paquete con sus acciones y montos calculados
          setPaquetesAgregados((prevPaquetes) => [
            ...prevPaquetes,
            { ...paqueteSeleccionado, secciones: accionesConMonto }
          ]);
          setIdPaquete('');  // Limpia la selección del select
        } else {
          setErrorPaquetes("El paquete ya ha sido agregado");
        }
      }
    }
  };

  // Función para quitar un paquete del listado de paquetes agregados
  const quitarPaquete = (id) => {
    setErrorPaquetes("");
    setPaquetesAgregados((prevPaquetes) =>
      prevPaquetes.filter((paquete) => paquete.id !== id)
    );

    // Elimina las cuotas asociadas a este paquete
    setCuotas((prevCuotas) => {
      const nuevasCuotas = { ...prevCuotas };
      delete nuevasCuotas[id];  // Elimina el paquete de las cuotas
      return nuevasCuotas;
    });
  };

  // Función para quitar una sección de un paquete
  const quitarSeccion = (e, paqueteId, seccionId) => {
    e.preventDefault();
    setPaquetesAgregados((prevPaquetes) =>
      prevPaquetes.map((paquete) =>
        paquete.id === paqueteId
          ? {
            ...paquete,
            secciones: paquete.secciones.filter(
              (seccion) => seccion.id !== seccionId
            ),
          }
          : paquete
      )
    );
  };

  // Función para quitar una acción dentro de una sección de un paquete
  const quitarAccion = (e, paqueteId, seccionId, accionId) => {
    e.preventDefault();
    setPaquetesAgregados((prevPaquetes) =>
      prevPaquetes.map((paquete) =>
        paquete.id === paqueteId
          ? {
            ...paquete,
            secciones: paquete.secciones.map((seccion) =>
              seccion.id === seccionId
                ? {
                  ...seccion,
                  acciones: seccion.acciones.filter(
                    (accion) => accion.id !== accionId
                  ),
                }
                : seccion
            ),
          }
          : paquete
      )
    );
  };

  // Función para actualizar el costo de una acción manualmente
  const actualizarCosto = (paqueteId, seccionId, accionId, nuevoCosto) => {
    setPaquetesAgregados(prevPaquetes =>
      prevPaquetes.map(paquete =>
        paquete.id === paqueteId
          ? {
            ...paquete,
            secciones: paquete.secciones.map(seccion =>
              seccion.id === seccionId
                ? {
                  ...seccion,
                  acciones: seccion.acciones.map(accion =>
                    accion.id === accionId
                      ? { ...accion, montoTotal: nuevoCosto }
                      : accion
                  )
                }
                : seccion
            )
          }
          : paquete
      )
    );
  };

  const actualizarCuotas = (paqueteId, nuevasCuotas) => {
    setCuotas((prevState) => {
      const cuotasActualizadas = { ...prevState };

      // 📌 Si las cuotas son exactamente las mismas, evitamos actualizar el estado
      if (JSON.stringify(cuotasActualizadas[paqueteId]) === JSON.stringify(nuevasCuotas)) {
        return prevState; // No hacemos nada si no hay cambios
      }

      // Eliminamos cuotas previas si hay un cambio en la forma de pago
      cuotasActualizadas[paqueteId] = nuevasCuotas;

      return cuotasActualizadas;
    });
  };


  // PLAZOS 
  // Función para agregar plazo
  const agregarPlazo = (e) => {
    e.preventDefault();
    setErrorPlazos('');

    if (idPlazo) {
      const plazoSeleccionado = plazoElaboracionDatos.find((plazo) => plazo.id == idPlazo);

      if (plazoSeleccionado) {
        // Verifica si el plazo ya ha sido agregado
        const plazoExiste = plazosAgregados.some((plazo) => plazo.plazos_detalle[0].plazo_id === plazoSeleccionado.id);
        if (!plazoExiste) {
          // Agrega el plazo con los días en cada detalle
          const plazoConDias = {
            ...plazoSeleccionado,
            plazos_detalle: plazoSeleccionado.plazos_detalle.map((detalle) => ({
              ...detalle,
              dias: dias[detalle.id] || 0, // Adjunta los días a cada detalle (por defecto 0)
            }))
          };

          setPlazosAgregados((prevPlazos) => [
            ...prevPlazos,
            plazoConDias
          ]);

          setIdPlazo(''); // Limpia la selección del select
        } else {
          setErrorPlazos("El plazo ya ha sido agregado");
        }
      }
    }
  };

  // Función para manejar los cambios en los inputs de días
  const handleInputChange = (e, plazoId, detalleId) => {
    const value = e.target.value;
    // Actualizar el valor de 'dias' en el estado de 'dias'
    setDias((prevDias) => ({
      ...prevDias,
      [detalleId]: value, // Usamos detalleId para diferenciar los plazos
    }));

    // Actualizar el valor de 'dias' dentro de plazosAgregados
    setPlazosAgregados((prevPlazos) => prevPlazos.map((plazo) => {
      if (plazo.id === plazoId) {
        // Encontramos el plazo correspondiente
        const updatedPlazosDetalle = plazo.plazos_detalle.map((detalle) => {
          if (detalle.id === detalleId) {
            // Actualizamos el detalle con el nuevo valor de días
            return {
              ...detalle,
              dias: value,
            };
          }
          return detalle;
        });
        return {
          ...plazo,
          plazos_detalle: updatedPlazosDetalle,
        };
      }
      return plazo;
    }));
  };

  // Función para quitar un plazo del listado de plazos agregados
  const quitarPlazo = (e, id) => {
    e.preventDefault()
    setErrorPlazos("");
    const nuevosPlazos = plazosAgregados.filter((plazo) => plazo.id !== id);

    setPlazosAgregados((prevPlazos) =>
      prevPlazos.filter((plazo) => plazo.id !== id)
    );
  };

  // Función para quitar una detalle de un plazo
  const quitarPlazoDetalle = (e, plazoId, plazoDetalleId) => {
    e.preventDefault();
    setPlazosAgregados((prevPlazos) =>
      prevPlazos.map((plazo) =>
        plazo.id === plazoId
          ? {
            ...plazo,
            plazos_detalle: plazo.plazos_detalle.filter(
              (plazoDetalle) => plazoDetalle.id !== plazoDetalleId
            ),
          }
          : plazo
      )
    );
  };

  const manejadorProgramaArquitectonico = (nivelesInput) => {
    let cantidad = parseInt(nivelesInput, 10);
    if (cantidad > 6) cantidad = 6;
    if (cantidad < 0) cantidad = 0;

    setNiveles(cantidad);

    // Ajusta los niveles agregados según el número de niveles
    if (cantidad > nivelesAgregados.length) {
      const nuevosNiveles = Array.from({ length: cantidad - nivelesAgregados.length }, () => ({ nivel: "", detalles: [] }));
      setNivelesAgregados([...nivelesAgregados, ...nuevosNiveles]);
    } else if (cantidad < nivelesAgregados.length) {
      setNivelesAgregados(nivelesAgregados.slice(0, cantidad));
    }
  };

  // Actualiza los espacios seleccionados para cada nivel
  const manejarEspaciosSeleccionados = (index, espaciosSeleccionados) => {
    const nuevosNiveles = [...nivelesAgregados];
    nuevosNiveles[index].detalles = espaciosSeleccionados;
    setNivelesAgregados(nuevosNiveles);
  };


  // Manejadores para actualizar nivel y detalle
  const manejarCambioNivel = (index, valor) => {
    const nuevosNiveles = [...nivelesAgregados];
    nuevosNiveles[index].nivel = valor;
    setNivelesAgregados(nuevosNiveles);
  };

  // -------------------------------
  // EDITAR COTIZACION 
  // ------------------------------------
  const editarCotizacion = async (e) => {
    setErrorGeneral('');
    e.preventDefault();
    const formData = new FormData(e.target);
    agregarDatosEmpresaUsuario(formData);
    setIsSubmitting(true);

    // Agregar el ID del proyecto que se está editando
    formData.append('id', id); // Asegúrate de tener `proyectoId` en tu estado

    // Agregar solo los IDs de los clientes seleccionados (según lo configurado en el backend)
    if (Array.isArray(clientesSeleccionados) && clientesSeleccionados.length > 0) {
      clientesSeleccionados.forEach((cliente, index) => {
        formData.append(`clientes[${index}][id]`, cliente.id); // Solo el ID del cliente
      });
    }

    // 🔹 POR AHORA COMENTAMOS ESTO, LO IREMOS AGREGANDO PASO A PASO

    if (Array.isArray(nivelesAgregados) && nivelesAgregados.length > 0) {
      nivelesAgregados.forEach((nivel, index) => {
        formData.append(`detalle_niveles[${index}][nivel]`, nivel.nivel);
        if (Array.isArray(nivel.detalles)) {
          nivel.detalles.forEach((espacio, espacioIndex) => {
            formData.append(`detalle_niveles[${index}][detalles_espacios][${espacioIndex}][espacio_id]`, espacio.id);
            formData.append(`detalle_niveles[${index}][detalles_espacios][${espacioIndex}][cantidad]`, espacio.cantidad);
          });
        }
      });
    }

    paquetesAgregados.forEach((paquete, index) => {
      formData.append(`paquetes[${index}][id]`, paquete.id);
      paquete.secciones.forEach((seccion, seccionIndex) => {
        formData.append(`paquetes[${index}][secciones][${seccionIndex}][id]`, seccion.id);
        seccion.acciones.forEach((accion, accionIndex) => {
          formData.append(`paquetes[${index}][secciones][${seccionIndex}][acciones][${accionIndex}][id]`, accion.id);
          formData.append(`paquetes[${index}][secciones][${seccionIndex}][acciones][${accionIndex}][monto]`, accion.montoTotal);
        });
      });
    });

    if (typeof cuotas === 'object' && cuotas !== null) {
      const cuotasArray = Object.values(cuotas).flat();
      cuotasArray.forEach((cuota, index) => {
        formData.append(`cuotas[${index}][paquete_id]`, cuota.paquete_id);
        formData.append(`cuotas[${index}][numero_cuota]`, cuota.numero_cuota);
        formData.append(`cuotas[${index}][monto_cuota]`, cuota.monto);
      });
    }

    if (Array.isArray(plazosAgregados) && plazosAgregados.length > 0) {
      plazosAgregados.forEach((tramite, tramiteIndex) => {
        tramite.plazos_detalle.forEach((plazo, index) => {
          formData.append(`plazos[${tramiteIndex}][${index}][plazo_detalle_id]`, plazo.id);
          formData.append(`plazos[${tramiteIndex}][${index}][dias]`, plazo.dias);
        });
      });
    }


    // 🔹 Intentamos enviar los datos configurados en el backend
    try {
      const respuestaProyecto = await consumirApi('POST', `cotizacion/editar/${id}`, formData);
      if (respuestaProyecto.success) {
        setErrorGeneral('ACTUALIZANDO...');
        setIsSubmitting(false);
        navigate('/cotizaciones');
      } else {
        setErrorGeneral(respuestaProyecto.error);
        setIsSubmitting(false);
      }
    } catch (error) {
      console.error("Error al editar cotización: ", error);
      setErrorGeneral("Ocurrió un error al editar la cotización");
      setIsSubmitting(false);
    }
  };

  return (
    <div className="w-full overflow-y-auto" style={{ maxHeight: 'calc(100vh - 60px)', background: "#f9f9f9" }}>
      {notificacion.estado && (
        <Notification estadoNotificacion={setNotificacion} type={notificacion.tipo} mensaje={notificacion.mensaje} />
      )}
      {cargando ? (
        <Spinner />
      ) : (
        tiposProyectoDatos.length === 0 ? (
          <div className="ml-5">No se encontraron tipos de proyectos</div>
        ) : (
          <div className="mx-5 mt-2">
            <Form onSubmit={editarCotizacion} texto='Actualizar cotización' isSubmitting={isSubmitting}>
              {/* Información general */}
              <fieldset className="border p-3 rounded-md mb-4 bg-white">
                <legend className="text-lg font-semibold px-2 text-[#00968]">Información General</legend>
                <div className="flex gap-8 ">
                  {/* Fecha cotización */}
                  <Input
                    name="fecha_cotizacion"
                    value={fechaCotizacion}
                    label="Fecha cotización"
                    type="date"
                    onChange={setFechaCotizacion}
                  />
                  {/* Tipo de proyecto */}
                  <Input
                    name="tipo_proyecto_id"
                    value={idTipoProyecto}
                    label="Tipo de Proyecto"
                    type="select"
                    onChange={manejadorTipoProyecto}
                    options={[
                      { value: '', label: 'Seleccionar' },
                      ...tiposProyectoDatos.map((tipo) => ({
                        value: tipo.id,
                        label: tipo.tipo_proyecto,
                      })),
                    ]}
                  />

                  {/* Clientes */}
                  <div className="flex items-center gap-2">
                    {/* Mostrar clientes seleccionados */}
                    <div className='flex items-center'>
                      <div className="flex flex-wrap gap-2">
                        {clientesSeleccionados.map((cliente) => (
                          <span
                            key={cliente.id}
                            className="px-2 py-1 bg-blue-100 text-blue-800 rounded-full flex items-center gap-2"
                          >
                            {cliente.nombres_cliente}
                            <button
                              type="button"
                              className="text-red-500 hover:text-red-700"
                              onClick={() => eliminarClienteSeleccionado(cliente.id)}
                            >
                              ✕
                            </button>
                          </span>
                        ))}
                      </div>

                      {/* Botón para abrir el modal */}
                      <Button type="save" texto="&#128269; Seleccionar Clientes" onClick={seleccionarCliente} />
                    </div>
                  </div>
                </div>
              </fieldset>

              {/* Proyecto */}
              <fieldset className="bg-white border p-3 rounded-md mb-4">
                <legend className="text-lg font-semibold px-2">Datos del Proyecto</legend>
                <div className="flex gap-8 items-center">
                  <div className='w-[400px]'>
                    <Input
                      name="nombre_proyecto"
                      value={nombreProyecto}
                      label="Nombre del Proyecto"
                      onChange={setNombreProyecto}
                    />
                  </div>
                  <Input name="ubicacion_id" value={idUbicacion} show="hidden" onChange={setIdUbicacion} />
                  <div className="flex gap-2 items-center">
                    <Input
                      name="ubicacion_general"
                      value={ubicacionGeneral}
                      label="Ubicación General"
                      readonly={true}
                      onChange={setUbicacionGeneral}
                    />
                    <Button type="save" texto="&#128269;" onClick={seleccionarUbicacion} />
                  </div>
                  <div className="flex-1">
                    <Input
                      name="ubicacion"
                      value={ubicacionEspecifica}
                      label="Ubicación Específica"
                      onChange={setUbicacionEspecifica}
                    />
                  </div>
                </div>
              </fieldset>

              {/* Detalles del Proyecto */}
              <fieldset className="bg-white border p-3 rounded-md mb-4">
                <legend className="text-lg font-semibold px-2">Detalles del Proyecto</legend>
                <div className="flex gap-8 items-center">
                  <div className='bg-red-50'>
                    <Input
                      type="number"
                      name="area_terreno"
                      value={areaTerreno}
                      label="Área Terreno"
                      onChange={setAreaTerreno}
                    />
                  </div>
                  <div className='bg-red-50'>
                    <Input
                      type="number"
                      name="numero_pisos"
                      value={numeroPisos}
                      label="Número de Pisos"
                      onChange={setNumeroPisos}
                    /></div>
                  <div className='bg-red-50'>
                    <Input
                      name="azotea"
                      value={azotea}
                      label="Azotea"
                      type="select"
                      onChange={setAzotea}
                      options={[
                        { value: '', label: 'Seleccionar' },
                        { value: "0", label: "NO" },
                        { value: "1", label: "SI" },
                      ]}
                    /></div>
                  <Input
                    type="number"
                    name="area_intervenir"
                    value={areaIntervenir}
                    label="Área a Intervenir"
                    onChange={setAreaIntervenir}
                  />
                </div>
              </fieldset>

              {/* Programa arquitectonico  */}
              <fieldset className="border p-3 rounded-md mb-4 bg-white">
                <legend className="text-lg font-semibold px-2">Programa arquitectonico</legend>
                <div className="flex gap-8 items-start">
                  <Input
                    type="number"
                    name="niveles"
                    value={niveles}
                    min={0}
                    label="Niveles"
                    onChange={manejadorProgramaArquitectonico}
                  />
                  <div className="mt-4 w-full">
                    {nivelesAgregados.map((nivel, index) => (
                      <ProgramaArquitectonico
                        key={index}
                        index={index}
                        nivel={nivel.nivel}
                        detalles={nivel.detalles}  // Detalles (espacios seleccionados con cantidades)
                        espaciosDatos={espaciosDatos}
                        manejarEspaciosSeleccionados={manejarEspaciosSeleccionados}
                        onNivelChange={manejarCambioNivel}
                      />
                    ))}
                  </div>
                </div>
              </fieldset>

              {/* Paquetes */}
              {paquetesDatos && paquetesDatos.length > 0 && (
                <fieldset className="border p-3 rounded-md bg-white">
                  <legend className="text-lg font-semibold px-2">Paquetes</legend>
                  {/* Select para Tipo de Paquete */}
                  <div className="flex items-start space-x-1">
                    <Input
                      name="paquete_id"
                      type="select"
                      value={idPaquete}
                      onChange={setIdPaquete}
                      options={[
                        { value: '', label: 'Seleccionar Paquete' },
                        ...paquetesDatos.map((paquete) => ({
                          value: paquete.id,
                          label: paquete.paquete,
                        })),
                      ]}
                    />
                    <Button texto="Agregar Paquete" type="report" onClick={(e) => agregarPaquete(e, costoUbicacion)} />
                    {errorPaquetes && <span className='text-red-600'>{errorPaquetes}</span>}
                  </div>

                  <div className='flex items-start gap-3 bg-white'>
                    {paquetesAgregados.length > 0 && (
                      <Paquete
                        paquetes={paquetesAgregados}
                        formaPago={formaPago}
                        cuotas={cuotas}
                        actualizarCuotas={actualizarCuotas}
                        quitarPaquete={quitarPaquete}
                        quitarAccion={quitarAccion}
                        quitarSeccion={quitarSeccion}
                        costoUbicacion={costoUbicacion}
                        areaIntervenir={areaIntervenir}
                        actualizarCosto={actualizarCosto}
                      />
                    )}
                  </div>

                </fieldset>
              )}

              {/* plazos de elaboracionm */}
              {plazoElaboracionDatos && plazoElaboracionDatos.length > 0 && (
                <fieldset className="border my-3 p-3 rounded-md bg-white">
                  <legend className="text-lg font-semibold px-2">Plazos de elaboración</legend>
                  {/* Select para plazos de elaboracion */}
                  <div className="flex items-start space-x-1">
                    <Input
                      name="paquete_id"
                      type="select"
                      value={idPlazo}
                      onChange={setIdPlazo}
                      options={[
                        { value: '', label: 'Seleccionar Plazo' },
                        ...plazoElaboracionDatos.map((plazo) => ({
                          value: plazo.id,
                          label: plazo.tramite,
                        })),
                      ]}
                    />
                    <Button texto="Agregar Plazo" type="report" onClick={(e) => agregarPlazo(e)} />
                    {errorPlazos && <span className='text-red-600'>{errorPlazos}</span>}
                  </div>
                  {/* plazos seleccionados  */}
                  <Plazo plazos={plazosAgregados} dias={dias} handleInputChange={handleInputChange} quitarPlazo={quitarPlazo} quitarPlazoDetalle={quitarPlazoDetalle} />

                </fieldset>
              )}

              {/* Mensajes de error */}
              {errorGeneral && <ErrorAlert type="error" message={errorGeneral} />}
            </Form>
          </div>
        )
      )}

      {/* Modal Seleccionar cliente*/}
      <Modal isOpen={mostrarModalSeleccionarCliente} title="Seleccionar cliente" onClose={limpiarCamposClientes} >
        <Input name="buscar_cliente" value={busquedaCliente} label="Documento-Nombres" onChange={manejarBusquedaCliente} />
        <DesplegableDinamico
          label="Seleccionar cliente"
          opciones={clientes}
          campo="nombres_cliente"
          onSeleccionar={manejarSeleccionCliente}
        />
        <Button texto='+ Nuevo cliente' onClick={() => window.open('/clientes', '_blank')} />
        {error && <ErrorAlert message={error} />}
      </Modal>

      {/* Modal Seleccionar ubicacion*/}
      <Modal isOpen={mostrarModalSeleccionarUbicacion} title="Seleccionar ubicacion" onClose={limpiarCamposUbicaciones} >
        <Input name="buscar_ubicacion" value={busquedaUbicacion} label="Ciudad" onChange={manejarBusquedaUbicacion} />
        <DesplegableDinamico
          label="Seleccionar ubicacion"
          opciones={ubicaciones}
          campo="ciudad"
          onSeleccionar={manejarSeleccionUbicacion}
        />
        <Button texto='+ Nueva ubicacion' onClick={() => window.open('/maestros/ubicaciones', '_blank')} />
        {error && <ErrorAlert message={error} />}
      </Modal>
    </div >
  )
}

export default Cotizaciones
